// VerseLabelArrows.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function VerseLabelArrows(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const bookList = useSelector((state) => state.home.bookList);
  // const confirmedBookChapterList = useSelector((state) => state.home.confirmedBookChapterList);
  const confirmedTabNumber = useSelector((state) => state.home.confirmedTabNumber);
  // const selectedVerses = useSelector((state) => state.verse.selectedVerses);
  //const tabVerseList = useSelector((state) => state.verse.tabVerseList);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  //const hasNoteVerses = useSelector((state) => state.verse.hasNoteVerses);

  const byVerseLabelArrowsSetTabVerseListNew = ({ newBook, newChapter, newShowLeftArrow, newShowRightArrow }) => {
    let list = tabVerseListNew.map((item, index) => index === confirmedTabNumber ? { ...item, book: newBook, chapter: newChapter, showLeftArrow: newShowLeftArrow, showRightArrow: newShowRightArrow } : item)
    dispatch(setTabVerseListNew(list));
  }

  let book = 0;
  let chapter = 0;
  let verseTotal = 0;
  let showLeftArrow = false;
  let showRightArrow = false;

  if (confirmedTabNumber >= 0) {
    let tabVerseListNewItem = tabVerseListNew[confirmedTabNumber];
    book = tabVerseListNewItem.book;
    chapter = tabVerseListNewItem.chapter;
    verseTotal = tabVerseListNewItem.verseTotal;
    showLeftArrow = tabVerseListNewItem.showLeftArrow;
    showRightArrow = tabVerseListNewItem.showRightArrow;
  }

  const handleOnClickLeft = () => {

    const { book: book, chapter: chapter } = tabVerseListNew[confirmedTabNumber];

    let newBook, newChapter, newShowLeftArrow, newShowRightArrow;

    if (chapter > 1) {
      newBook = book;
      newChapter = chapter - 1;
    } else if (book > 1) {
      newBook = book - 1;
      newChapter = bookList[newBook - 1].Chapters;
    } else {
      newBook = book;
      newChapter = chapter;
    } 

    if (newBook === 1 && newChapter === 1) {
      newShowLeftArrow = false;
      newShowRightArrow = true;
    } else {
      newShowLeftArrow = true;
      newShowRightArrow = true;
    }

    postHistoryListItem({book: newBook, chapter: newChapter}, 'VerseLabelArrows');
    byVerseLabelArrowsSetTabVerseListNew({ newBook, newChapter, newShowLeftArrow, newShowRightArrow });

    let currentTabVerseListNewItem = tabVerseListNew[confirmedTabNumber];
    if (currentTabVerseListNewItem.book !== newBook || currentTabVerseListNewItem.chapter !== newChapter) {
      let newTabVerseListNewItem = { ...tabVerseListNew[confirmedTabNumber], book: newBook, chapter: newChapter, verses: [], read: false, showLeftArrow: newShowLeftArrow, showRightArrow: newShowRightArrow };
      const updatedTabVerseListNew = replaceTabVerseListNewItem(tabVerseListNew, confirmedTabNumber, newTabVerseListNewItem);
      dispatch(setTabVerseListNew(updatedTabVerseListNew));    
    }

    // let currentSelectedVersesChild = selectedVerses[confirmedTabNumber];
    // let newSelectedVersesChild;
    // if (currentSelectedVersesChild.book !== newBook || currentSelectedVersesChild.chapter !== newChapter) {
    //   newSelectedVersesChild = { book: newBook, chapter: newChapter, selected: [] };
    //   const updatedSelectedVerses = replaceSelectedVersesChild(selectedVerses, confirmedTabNumber, newSelectedVersesChild);
    //   dispatch(setSelectedVerses(updatedSelectedVerses));
    // }

  };

  const handleOnClickRight = () => {

    // dispatch(setCircularProgressText(''));

    const { book: book, chapter: chapter } = tabVerseListNew[confirmedTabNumber];
    const chapters = bookList[book - 1].Chapters;

    let newBook, newChapter, newShowLeftArrow, newShowRightArrow;

    if (chapter === chapters) {
      if (book < 66) {
        newBook = book + 1;
        newChapter = 1;
      } else {
        newBook = book;
        newChapter = chapter;
      }
    } else {
      newBook = book;
      newChapter = chapter + 1;
    }

    if (newBook === 66 && newChapter === 22) {
      newShowLeftArrow = true;
      newShowRightArrow = false;
    } else {
      newShowLeftArrow = true;
      newShowRightArrow = true;
    }
    
    postHistoryListItem({book: newBook, chapter: newChapter}, 'VerseLabelArrows');
    byVerseLabelArrowsSetTabVerseListNew({ newBook, newChapter, newShowLeftArrow, newShowRightArrow });

    // let currentTabVerseListChild = tabVerseList[confirmedTabNumber];
    // let newVerseListChild;
    // if (currentTabVerseListChild.book !== newBook || currentTabVerseListChild.chapter !== newChapter) {
    //   newVerseListChild = { book: newBook, chapter: newChapter, details: [] };
    //   const updatedTabVerseList = replaceTabVerseListChild(tabVerseList, confirmedTabNumber, newVerseListChild);
    //   dispatch(setTabVerseList(updatedTabVerseList));
    // }

    let currentTabVerseListNewItem = tabVerseListNew[confirmedTabNumber];
    if (currentTabVerseListNewItem.book !== newBook || currentTabVerseListNewItem.chapter !== newChapter) {
      let newTabVerseListNewItem = { ...tabVerseListNew[confirmedTabNumber], book: newBook, chapter: newChapter, verses: [], read: false, showLeftArrow: newShowLeftArrow, showRightArrow: newShowRightArrow };
      const updatedTabVerseListNew = replaceTabVerseListNewItem(tabVerseListNew, confirmedTabNumber, newTabVerseListNewItem);
      dispatch(setTabVerseListNew(updatedTabVerseListNew));    
    }

    // let currentSelectedVersesChild = selectedVerses[confirmedTabNumber];
    // let newSelectedVersesChild;
    // if (currentSelectedVersesChild.book !== newBook || currentSelectedVersesChild.chapter !== newChapter) {
    //   newSelectedVersesChild = { book: newBook, chapter: newChapter, selected: [] };
    //   const updatedSelectedVerses = replaceSelectedVersesChild(selectedVerses, confirmedTabNumber, newSelectedVersesChild);
    //   dispatch(setSelectedVerses(updatedSelectedVerses));
    // }    

  };

  if (book > 0 && chapter > 0) {
    return (
      <div>

      <Fab
        size='small'
        sx={{
          position: 'fixed',
          left: 16,
          bottom: 32,
          backgroundColor: 'primary.main',
          color: 'white',
          boxShadow: 'none',
          // opacity: 0.7,
          '&:hover': { color: 'white', backgroundColor: 'primary.main' }, 
          display: showLeftArrow ? 'flex' : 'none'        
        }}
        onClick={handleOnClickLeft}
      >
        <WestIcon />
      </Fab>

      <Fab 
        variant='extended' 
        disabled
        size='large'
        sx={{
          borderRadius: '4px',
          size: 'small',
          position: 'fixed',
          bottom: 32,
          left: '50%',          // center horizontally
          transform: 'translateX(-50%)', // adjust for the FAB's width    
          color: 'white',      
          boxShadow: 'none',
          // opacity: 0.7,
          '&.Mui-disabled': { color: 'white', backgroundColor: 'primary.main' }
        }}        
      >
      <span>{bookList[book-1].Chinese_Code} { chapter } : 1 - { verseTotal }</span>
      </Fab>  

      <Fab
        size='small'
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 32,
          backgroundColor: 'primary.main',
          color: 'white',
          boxShadow: 'none',
          // opacity: 0.7,
          '&:hover': { color: 'white', backgroundColor: 'primary.main' },     
          display: showRightArrow ? 'flex' : 'none'        
        }}
        onClick={handleOnClickRight}
      >
        <EastIcon />
      </Fab>

      </div>     

    );
  } else {
    return null;
  }
}